import { useTranslation } from 'react-i18next'

import { ChatCircleDotsIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { AiReveniIcon, CardTitle, Chip } from '@reveni-io/reveni-ui'

import CustomerNotesCardMenu from '../CustomerNotesCardMenu/CustomerNotesCardMenu'
import * as Styles from './styles'

const CustomerNotesCardHeader = ({ onExport, exporting }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <CardTitle>
      <Styles.Title>
        <ChatCircleDotsIcon size={24} weight="light" />
        {t('Notas de clientes')}
        <Chip
          Icon={AiReveniIcon}
          label={t('Análisis IA')}
          backgroundColor={theme.colors.ai.surface}
          color={theme.colors.ai.hover}
        />
      </Styles.Title>
      {onExport && <CustomerNotesCardMenu onExport={onExport} disabled={exporting} />}
    </CardTitle>
  )
}

export default CustomerNotesCardHeader
